import { DefaultLink } from '@legacy/components/global/DefaultLink';
import DesignSevenVerification from '@legacy/components/global/DesignSevenVerification';
import { LinkProvider } from '@legacy/components/global/LinkProvider';
import { LoginCallbackRedirection } from '@legacy/components/global/LoginCallbackRedirection';
import { MuiWrapper } from '@legacy/components/global/MuiWrapper';
import RefetchControl from '@legacy/components/global/RefetchControl';
import { ShortcutSystem } from '@legacy/components/global/ShortcutSystem';
import { ToastContainer } from '@legacy/components/global/ToastContainer';
import UserLanguage from '@legacy/components/global/UserLanguage';
import { RedirectDesignSeven } from '@legacy/routers/RedirectDesignSeven';
import MobileNavigationStoreProvider from '@legacy/stores/MobileNavigationStore';
import cx from 'classnames';
import { Outlet } from 'react-router';

import { useGetSiteLocale } from '@/legacy/apis/indexAPI';
import { LocaleProvider } from '@/legacy/components/global/LocaleProvider';

interface LegacyLayoutProps {
  isInNewNavigation?: boolean;
}

const useGetLocale = () => {
  const { siteLocale } = useGetSiteLocale();

  return siteLocale ?? 'en-GB';
};

export const LegacyLayout = ({
  isInNewNavigation = false,
}: LegacyLayoutProps) => {
  return (
    <LocaleProvider value={{ getLocale: useGetLocale }}>
      <LinkProvider value={DefaultLink}>
        <MobileNavigationStoreProvider>
          <MuiWrapper>
            <ShortcutSystem />
            <RefetchControl />
            <LoginCallbackRedirection />
            <DesignSevenVerification />
            <UserLanguage />
            <RedirectDesignSeven />
            <ToastContainer />
            {/* needed to better separate global styles between new and legacy scope */}
            <div className={cx({ ['LegacyGlobalStyles']: !isInNewNavigation })}>
              <Outlet />
            </div>
          </MuiWrapper>
        </MobileNavigationStoreProvider>
      </LinkProvider>
    </LocaleProvider>
  );
};
